<template>
  <div class="client-staff">
    <div class="client-search">
      <el-input
        class="base-msg-input"
        size="mini"
        v-model="params.customerName"
        suffix-icon="el-icon-search"
        placeholder="客户姓名(昵称)"
        @blur="onInputBlur"
        @clear="onInputBlur"
        clearable
      ></el-input>
      <el-button size="mini">最后访问时间</el-button>
      <el-date-picker
        v-model="dateTime"
        size="mini"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="~"
        :editable="false"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        @change="selectTime"
        clearable
        style="width: 240px; margin-right: 10px"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
      <el-input
        class="base-msg-input"
        size="mini"
        v-model="params.phoneNumber"
        suffix-icon="el-icon-search"
        placeholder="手机号码"
        @blur="onInputBlur"
        @clear="onInputBlur"
        clearable
      ></el-input>
      <el-button size="mini">交互行为</el-button>
      <el-select
        v-model="params.interactionBehavior"
        placeholder="请选择"
        size="mini"
        clearable
        @change="getList"
      >
        <el-option
          v-for="item in options1"
          :key="item.value"
          :label="item.label"
          :value="item.label"
        >
        </el-option>
      </el-select>
      <el-checkbox v-model="checked" style="margin: 0 30px" @change="getList"
        >只看未成交</el-checkbox
      >
    </div>
    <el-row :gutter="20">
      <el-col>
        <el-table
          size="small"
          :data="tableData"
          fit
          highlight-current-row
          align="center"
          :header-cell-style="{ background: '#F9F9F9' }"
          height="calc(100vh - 235px)"
          ref="cusChatTable"
          style="font-size: 13px"
        >
          <el-table-column type="index" min-width="50"> </el-table-column>
          <el-table-column prop="customerName" label="客户" min-width="120">
            <template slot-scope="scope">
              <div>
                <el-row :gutter="20">
                  <el-col :span="30" style="padding: 0">
                    <el-avatar
                      size="medium"
                      shape="square"
                      :src="scope.row.avatar"
                    ></el-avatar>
                  </el-col>
                  <el-col :span="70">
                    <div v-if="scope.row.customerName != null">
                      {{ scope.row.customerName }}
                    </div>
                    <div v-else>--</div>
                    <div style="color: #a09f9fc9; font-size: 12px">
                      {{ scope.row.customerName }}
                      <span
                        style="color: rgb(70, 189, 10)"
                        v-if="scope.row.type == 1"
                      >
                        @微信</span
                      >
                      <span style="color: rgb(8, 168, 231)" v-else>
                        @企业微信</span
                      >
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gender" label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.gender == "M" ? "男" : "女" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phoneNumber" label="手机号"></el-table-column>
          <el-table-column prop="introducer" label="介绍人"></el-table-column>
          <el-table-column prop="consultant" label="所属顾问"></el-table-column>
          <el-table-column prop="transactionStatus" label="成交状态">
            <template slot-scope="scope">
              <span>{{
                scope.row.transactionStatus == "A"
                  ? "成交"
                  : scope.row.transactionStatus == "B"
                  ? "未成交"
                  : "未上门"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="visitCount" label="访问次数"></el-table-column>
          <el-table-column
            prop="visitTime"
            label="最后访问时间"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="interactionBehavior" label="交互行为">
            <template slot-scope="scope">
              <div>
                <el-tag
                  style="margin: 5px 4px 0 0"
                  v-for="item in scope.row.tagIdList"
                  :key="item.tagId"
                  v-show="item.tagName != null"
                  size="small"
                >
                  {{ item.tagName }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="分配跟进时间"
            min-width="120"
          ></el-table-column>
          <el-table-column prop="recentTime" label="操作">
            <template slot-scope="scope">
              <div style="color: #409eff; cursor: pointer">
                <div @click="getCustomerDetail(scope.row)">查看详情</div>
                <div @click="addRemarks(scope.row)">添加备注</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Pagination
      v-bind:childMsg="pageparm"
      :pageSizes="pageSizes"
      @callBack="callBack"
    ></Pagination>
    <StaffTree
      title="添加成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="currentSelectMember"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
      ref="tree"
    ></StaffTree>

    <!-- 添加备注 -->
    <el-dialog
      title="填写备注"
      :visible.sync="dialogVisible2"
      width="25%"
      @close="dialogVisible2 = false"
    >
      <el-input
        type="textarea"
        :rows="4"
        placeholder="请输入备注内容"
        v-model.trim="textarea"
        maxlength="50"
        show-word-limit
      >
      </el-input>
      <div style="text-align: right; margin-top: 15px">
        <el-button size="mini" @click="dialogVisible2 = false">取消</el-button>
        <el-button
          size="mini"
          type="primary"
          :disabled="textarea.trim().length == 0"
          @click="handleSubmit"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="客户详情"
      :visible.sync="dialogVisible1"
      width="35%"
      @close="dialogVisible1 = false"
    >
      <div class="dialog">
        <div class="list">
          <div class="left">
            <div class="avatar">
              <el-image
                style="width: 40px; height: 40px; border-radius: 4px"
                :src="
                  customerInfo.avatar
                    ? customerInfo.avatar
                    : 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
                "
              ></el-image>
            </div>
            <div style="margin-left: 10px">
              <div style="margin-bottom: 4px">
                姓名：{{ customerInfo.customerName || "--" }}
              </div>
              <div>昵称：昵称</div>
            </div>
          </div>
          <div class="item">
            性别：{{ customerInfo.gender == "M" ? "男" : "女" }}
          </div>
          <div class="item">手机号：{{ customerInfo.phoneNumber || "--" }}</div>
          <div class="item">介绍人：{{ customerInfo.introducer || "--" }}</div>
          <div class="item">
            所属顾问：{{ customerInfo.consultant || "--" }}
          </div>
          <div class="item">
            成交状态：
            {{
              customerInfo.transactionStatus == "A"
                ? "成交"
                : customerInfo.transactionStatus == "B"
                ? "未成交"
                : "未上门"
            }}
          </div>
        </div>
        <div class="list">
          <div style="font-weight: bold">浏览记录：</div>

          <el-scrollbar style="height: 150px">
            <div
              v-if="
                customerInfo.wxUserProductRecord &&
                  customerInfo.wxUserProductRecord.length == 0
              "
              style="padding-top: 60px; text-align: center"
            >
              暂无记录
            </div>
            <template v-for="i in customerInfo.wxUserProductRecord" v-else>
              <div class="item">
                {{ handleDate(i.pbasTime) }}<span>{{ i.pbasSname }}</span>
              </div>
              <!-- <div class="item">2023.6.30 <span>浏览商品-水光2.22</span></div>
            <div class="item">2023.6.30 <span>浏览商品-水光2.22</span></div> -->
            </template>
          </el-scrollbar>
          <div style="margin-top: 15px; font-weight: bold">跟进记录：</div>
          <el-scrollbar style="height: 150px">
            <div
              v-if="!customerInfo.leadsRecordFollow"
              style="padding-top: 60px; text-align: center"
            >
              暂无记录
            </div>
            <template v-for="y in customerInfo.leadsRecordFollow" v-else>
              <div class="item">
                {{ handleDate(y.visitTime)
                }}<span>{{ y.follower || "--" }}</span>
              </div>
              <div>备注：{{ y.remark || "--" }}</div>
            </template>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import { getCustomer, activityTagType } from "@/api/activeCode/activeCode.js";
import {
  addRemark,
  getLeadsPool,
  getCustomerDetails,
} from "@/api/marketingRadar/index.js";
import { Message } from "element-ui";
import dayjs from "dayjs";
export default {
  name: "CusChatSupervise",
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      textarea: "",
      activities: [
        // {
        //   content: "活动按期开始",
        //   timestamp: "2018-04-15",
        // },
        // {
        //   content: "通过审核",
        //   timestamp: "2018-04-13",
        // },
        // {
        //   content: "创建成功",
        //   timestamp: "2018-04-11",
        // },
      ],
      pState: 1,
      tags: [
        { name: "标签一", type: "" },
        { name: "标签二", type: "success" },
        { name: "标签三", type: "info" },
        { name: "标签四", type: "warning" },
        { name: "标签五", type: "danger" },
      ],
      options1: [
        {
          value: "选项1",
          label: "登录商城",
        },
        {
          value: "选项2",
          label: "浏览商品",
        },
        {
          value: "选项3",
          label: "浏览活动",
        },
        {
          value: "选项4",
          label: "浏览医生",
        },
        {
          value: "选项5",
          label: "浏览文章",
        },
        {
          value: "选项6",
          label: "浏览案例",
        },
      ],
      value: "",
      title: "选择添加人",
      tableData: [],
      // loading: false,
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      dateTime: "",
      //查询列表初始参数
      formInline: {
        ctmNameOrPhoneOrCtmCode: "", //姓名或者手机或者卡号
        userIdList: [], //成员userId集合
        tagIdList: [], //标签tagId集合
        startTime: null, //开始时间
        endTime: null, //结束时间
        pageNum: 1, //页码 默认1
        pageSize: 20, //每页条数  默认10
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      dialogVisibleTree: false, //添加人弹窗开关
      currentSelectMember: [], //组件中要显示-选中的成员
      searchMenNames: [], //当前 搜索框-选中的成员
      // markLength:0,
      // 客户管理
      props: { multiple: true },
      options: [],
      tagsData: [],
      customerInfo: {},
      info: {},
      params: {
        customerName: "", //客户姓名
        introducer: "", //介绍人
        follower: "", //跟进人2
        transactionStatus: "", //成交状态
        visitCount: "", // 访问次数
        interactionBehavior: "", // 交互行为
        remarks: "", // 备注
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        pageNum: 1, // 当前页
        pageSize: 20, // 当前页数量
        phoneNumber: "", //手机号
      },
      checked: false,
    };
  },
  created() {
    // this.getCustomer();
    this.getList();
    this.getActivityTagGroup();
  },
  watch: {
    // markLength(val){
    //   if(this.markLength == this.currentSelectMember.length){
    //     this.getCustomer()
    //   }
    // },
    tagsData(val) {
      this.formInline.pageNum = 1;
      this.formInline.tagIdList = [];
      if (val.length != 0) {
        val.map((v) => {
          this.formInline.tagIdList.push(v[1]);
        });
      }
      this.getCustomer();
    },
  },
  methods: {
    addRemarks(row) {
      this.info = row;
      this.dialogVisible2 = true;
    },
    getList() {
      this.params.transactionStatus = this.checked ? "B" : "";
      getLeadsPool(this.params, localStorage.getItem("Authorization")).then(
        (res) => {
          this.tableData = res.data.list;
          this.pageparm.total = res.data.total;
          console.log("res");
        }
      );
    },
    handleSubmit() {
      if (this.textarea.length == 0) {
        Message.warning("备注不能为空!");
        return;
      }
      addRemark(
        {
          customerId: this.info.customerId,
          remark: this.textarea,
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        Message.success("操作成功");
        this.dialogVisible2 = false;
        this.textarea = "";
      });
    },
    // 获取客户详情
    getCustomerDetail(row) {
      console.log("row", row);
      getCustomerDetails(
        {
          customerId: row.customerId,
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        this.customerInfo = res.data;
        this.dialogVisible1 = true;
      });
    },
    handleDate(date) {
      return dayjs(date).format("YYYY.MM.DD");
    },
    removeTag(item) {
      this.$nextTick(() => {
        this.$refs.tree.clickCurrrntFn(item, true);
      });
    },
    //获取标签组数据
    getActivityTagGroup() {
      activityTagType(
        { pageNum: 1, pageSize: 1000 },
        localStorage.getItem("Authorization")
      )
        .then((res) => {
          if (res.error.code == 200) {
            let groupList = res.data.records;
            groupList.map((v) => {
              let obj = {
                value: v.groupId,
                label: v.groupName,
                children: [],
              };
              if (v.hmcActivityTagList.length != 0) {
                v.hmcActivityTagList.map((s) => {
                  obj.children.push({
                    value: s.tagId,
                    label: s.tagName,
                  });
                });
              }
              this.options.push(obj);
            });
          }
        })
        .catch((err) => {});
    },
    //分页回调
    callBack(parm) {
      this.params.pageNum = parm.currentPage;
      this.params.pageSize = parm.pageSize;
      this.getCustomer();
    },
    //获取客户列表
    getCustomer() {
      // this.loading = false;
      getCustomer(this.formInline, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.tableData = res.data.result;
            this.pageparm.total = res.data.total;
          }
        })
        .catch((err) => {});
    },
    //选择时间
    selectTime(val) {
      this.pageNum = 1;
      if (val == null) {
        this.params.startTime = "";
        this.params.endTime = "";
      } else {
        this.params.startTime = val[0];
        this.params.endTime = val[1];
      }
      this.getList();
    },
    //客户姓名、卡号、手机号 输入框失焦
    onInputBlur() {
      this.pageNum = 1;
      this.getList();
    },
    //打开添加人弹窗回调
    clickAddMember(type = 1) {
      //type 1 外部跟进人  2 跟进分配组织架构
      this.pState = type;
      this.dialogVisibleTree = true;
    },
    //关闭添加人弹窗回调
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    // 搜索-添加成员---清空
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = [];
      this.formInline.userIdList = [];
      this.formInline.pageNum = 1;
      // this.markLength = 0
      this.getCustomer();
    },
    //添加人弹窗确认回调
    clickSubmitTree(val) {
      console.log("bbbbbbbbbbbbbbbbbb");
      this.currentSelectMember = val.currentMember;
      this.formInline.pageNum = 1;
      this.formInline.userIdList = [];
      this.searchMenNames = val.currentIdName;
      //   console.log("");
      console.log("Val", val);
      //   if(this.pState == 1){
      val.sendArray.forEach((item) => {
        this.formInline.userIdList.push(item.userId);
      });
      //   }else {
      //     val.sendArray.forEach((item) => {
      //     this.activities.push({
      //         ...item,
      //         content: item.userName,
      //         timestamp: item.userId
      //     });
      //   });
      //   }

      //   this.getCustomer();
      this.dialogVisibleTree = false;
    },
    selectTags(val) {
      // console.log(val)
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  display: flex;
  height: 350px;
  .list {
    flex: 1;
    &:first-child {
      border-right: 1px solid #ddd;
    }
    &:last-child {
      padding-left: 30px;
    }
    .item {
      margin: 10px 0;
      span {
        margin-left: 15px;
      }
    }
    .left {
      display: flex;
    }
  }
}
.client-staff {
  .client-search {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    /deep/.add-per-input {
      margin-right: 10px;
      width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      cursor: pointer;
      .el-icon-close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 5px;
      }
    }
    .base-msg-input {
      width: 190px;
      margin-right: 10px;
    }
    .date-input {
      width: 240px;
      margin-right: 10px;
    }
    .add-per-input {
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .client-search .el-tag--plain {
    border-color: #dcdfe6;
    color: #c0c4cf;
  }
  .welcomeDia {
    .el-dialog__body {
      min-height: 200px;
      margin: 20px 20px;
      padding: 0px;
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
  .treeDia {
    .el-dialog__body {
      min-height: 400px;
    }
  }
  .custom-tree-node {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .span-line {
    width: 1px;
    height: 470px;
    background-color: #eee;
    display: inline-block;
    position: relative;
    left: 80%;
  }
  .select-right {
    display: flex;
    justify-content: space-between;
    padding: 8px 9%;
    width: 80%;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    &:hover {
      background-color: #f0f7ff;
    }
  }
  .el-tag--plain {
    border-color: #606266;
    color: #606266;
  }
}
</style>
